<script setup>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import Message from 'primevue/message'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  roleName: {
    type: String,
    default: ''
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:visible', 'confirm'])

function confirmDelete() {
  if (props.loading) return
  emit('confirm')
}

function closeDialog() {
  if (props.loading) return
  emit('update:visible', false)
}
</script>

<template>
  <Dialog
    :visible="visible"
    header="Подтверждение удаления"
    :modal="true"
    :closable="!loading"
    :close-on-escape="!loading"
    :style="{ width: 'min(400px, 95vw)' }"
    @update:visible="closeDialog"
  >
    <div class="confirm-dialog">
      <Message severity="warn" :closable="false">
        <div class="warning-content">
          <i class="pi pi-exclamation-triangle"></i>
          <span>Внимание!</span>
        </div>
      </Message>
      
      <p>Вы действительно хотите удалить роль <strong>«{{ roleName }}»</strong>?</p>
      <p class="warning-text">Это действие может повлиять на права доступа пользователей с этой ролью.</p>

      <div class="dialog-actions">
        <Button
          label="Отмена"
          icon="pi pi-times"
          class="p-button-text"
          :disabled="loading"
          @click="closeDialog"
        />
        <Button
          label="Удалить"
          icon="pi pi-trash"
          severity="danger"
          :loading="loading"
          :disabled="loading"
          @click="confirmDelete"
        />
      </div>
    </div>
  </Dialog>
</template>

<style scoped>
.confirm-dialog {
  padding: 8px 0;
}

.warning-content {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
}

.warning-content i {
  font-size: 18px;
}

.warning-text {
  color: #e74c3c;
  font-size: 14px;
  margin-top: 12px;
}

.dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}
</style>
